export { TwoColumnRiver } from './TwoColumnRiver';
export type { Props as TwoColumnRiverProps } from './TwoColumnRiver';
